<script setup lang="ts">
import {computed} from "vue";
import {Broadcast} from "@/types";
import {usePage} from "@inertiajs/vue3";

const page = usePage()

const broadcast = computed(() => page.props.broadcast as Broadcast | null)

const isBroadcastVisible = computed(() => {
    return broadcast.value !== null;
});
</script>

<template>
    <v-banner
        v-if="isBroadcastVisible"
        :bg-color="broadcast?.type"
        class="font-weight-bold"
    >
        <v-icon class="mr-3">
            mdi-bullhorn-outline
        </v-icon>
        {{ broadcast?.message }}
    </v-banner>
</template>

<style scoped>

</style>
